// Do NOT add "use client" to this file
import { getImage } from "@faire/retailer-visitor-shared/features/MarketplaceItems/ProductDetailsTile/getImage";
// This is RSC ready as long as we searialize brand on server.
export var productOnlyImagePropsILeanProductTileAdapter = function(productTile, brandName, showVerticalImagery) {
    var _productTile_product, _productTile_product1;
    var image = getImage(productTile);
    var _productTile_product_name;
    return {
        productToken: (_productTile_product = productTile.product) === null || _productTile_product === void 0 ? void 0 : _productTile_product.token,
        image: image,
        productName: (_productTile_product_name = (_productTile_product1 = productTile.product) === null || _productTile_product1 === void 0 ? void 0 : _productTile_product1.name) !== null && _productTile_product_name !== void 0 ? _productTile_product_name : "",
        brandName: brandName,
        showVerticalImagery: showVerticalImagery
    };
};
